var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"vue-component"},[_c('div',{staticClass:"content"},[_c('a',{staticClass:"el-button",staticStyle:{"margin-right":"10px","text-decoration":"none"},attrs:{"href":_vm.node.attrs.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.node.attrs.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }